import { useEffect, useState } from 'react';
import { onResizeEffect } from '../scripts/utils';


export default function useIsMobile( breakpoint = 900 ) {

    const getIsMobile = () => window.innerWidth <= breakpoint;

    const [ isMobile, setIsMobile ] = useState( getIsMobile() );
    
    const onResize = () => {
        setIsMobile( getIsMobile() );
    };
    
    useEffect( onResizeEffect( onResize ), [] );
    
    return isMobile;
}